<template>
  <a class="p-login-form-suppl__link" :href="`mailto:${mailAddress}`">{{ linkText }}</a>
</template>

<script>
export default {
  props: {
    mailAddress: String,
    linkText: String,
  },
}
</script>
